import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Panel } from 'primereact/panel';
import { Button } from 'primereact/button';
import { injectIntl, defineMessages } from 'react-intl';
import apollo from '../../../services/apollo';
import { GENERATE_SURVEY_PROJECT_STATUS_REPORT, GENERATE_SURVEY_PROJECT_MANAGERS_REPORT } from './mutations';
import { withGrowl } from '../../../components/GrowlNotifications';


const intlMessages = defineMessages({
  panelHeader: {
    id: 'survey_project.generate.status_report.panel.header',
    defaultMessage: 'Report Generation',
  },
  buttonLabel: {
    id: 'survey_project.generate.status_report.button.label',
    defaultMessage: 'Generate Status Report',
  },
  managersReportButtonLabel: {
    id: 'survey_project.generate.managers_report.button.label',
    defaultMessage: 'Generate Managers Report',
  },
  errorMesssage: {
    id: 'survey_project.generate.error.message',
    defaultMessage: 'There was an error generating Status Report.',
  },
});

const SurveyProjectReports = ({
  accountId, surveyProjectId, growl, intl: { formatMessage },
}) => {
  const [generationInProgress, setGenerationInProgress] = useState(false);

  const generateStatusReport = async () => {
    try {
      setGenerationInProgress(true);
      const report = await apollo.mutate({
        mutation: GENERATE_SURVEY_PROJECT_STATUS_REPORT,
        variables: {
          input: {
            accountId,
            surveyProjectId,
          },
        },
      });
      setGenerationInProgress(false);
      window.open(report.data.generateSurveyProjectStatusReport.url, '_blank');
    } catch (error) {
      growl.show({
        severity: 'error',
        summary: 'Error',
        detail: formatMessage(intlMessages.errorMesssage),
      });
      setGenerationInProgress(false);
    }
  };

  const generateManagersReport = async () => {
    try {
      setGenerationInProgress(true);
      const report = await apollo.mutate({
        mutation: GENERATE_SURVEY_PROJECT_MANAGERS_REPORT,
        variables: {
          input: {
            accountId,
            surveyProjectId,
          },
        },
      });
      setGenerationInProgress(false);
      window.open(report.data.generateSurveyProjectManagersReport.url, '_blank');
    } catch (error) {
      growl.show({
        severity: 'error',
        summary: 'Error',
        detail: formatMessage(intlMessages.errorMesssage),
      });
      setGenerationInProgress(false);
    }
  };

  return (
    <Panel header={formatMessage(intlMessages.panelHeader)}>
      <Button
        disabled={generationInProgress}
        label={formatMessage(intlMessages.buttonLabel)}
        onClick={generateStatusReport}
      />
      <Button
        disabled={generationInProgress}
        label={formatMessage(intlMessages.managersReportButtonLabel)}
        onClick={generateManagersReport}
      />
    </Panel>
  );
};

SurveyProjectReports.propTypes = {
  accountId: PropTypes.string.isRequired,
  surveyProjectId: PropTypes.string.isRequired,
  growl: PropTypes.shape({
    show: PropTypes.func.isRequired,
  }).isRequired,
  intl: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default withGrowl(injectIntl(SurveyProjectReports));
